const initialCurrentThread = {
    title: '',
    id: null,
    created: null,
    updated: null,
    finagentLibraryIds: [],
};

const initialQuestionUsage = {
    questionsAsked: 0,
    questionsLeft: 0,
    questionsLimit: 10,
}

const initialState = {
    threads: [],
    currentThread: initialCurrentThread,
    isThreadsLoading: false,
    isCreatingNewThread: false,
    isOpenThreadsMobile: false,
    preservedQuestion: '',
    questionUsage: initialQuestionUsage,
    isLoadingQuestionUsage: false,
    isReachFreePlanLimit: false,
    wishListIsins: [],
};

const state = () => initialState;

const mutations = {
    setThreads(state, payload) {
        state.threads = payload
    },
    setCurrentThread(state, payload) {
        state.currentThread = payload
    },
    setCurrentThreadTitle(state, newTitle) {
        state.currentThread = { ...state.currentThread, title: newTitle }
    },
    updateThreadTitleById(state, payload) {
        const { id, title } = payload
        state.threads = state.threads.map((thread) => {
            if (thread.id === id) {
                thread.title = title
            }

            return thread;
        })
    },
    addThread(state, payload) {
        state.threads = [payload, ...state.threads]
    },
    resetFinAgentState(state, { preserveProperties = [] } = {}) {
        Object.keys(initialState).forEach(key => {
            if (!preserveProperties.includes(key)) {
                if (typeof initialState[key] === 'object' && initialState[key] !== null) {
                    state[key] = JSON.parse(JSON.stringify(initialState[key]));
                } else {
                    state[key] = initialState[key];  
                }  
            }  
        });        
    },
    removeThread(state, id) {
        state.threads = state.threads.filter((c) => c.id !== id)
        
        if (state.currentThread.id === id) {
            state.currentThread = state.threads[0] || initialCurrentThread;
        }
    },
    renameThread(state, payload) {
        const { id, newTitle } = payload
        const foundThreadIndex = state.threads.findIndex((c) => c.id === id)
        const tempThreads = [...state.threads]
        tempThreads[foundThreadIndex].title = newTitle
        state.threads = tempThreads
    },
    setIsThreadsLoading(state, payload) {
        state.isThreadsLoading = payload
    },
    setOpenThreadsMobile(state, payload) {
        state.isOpenThreadsMobile = payload;
    },
    setPreservedQuestion(state, payload) {
        state.preservedQuestion = payload;
    },
    setIsCreatingNewThread(state, payload) {
        state.isCreatingNewThread = payload;
    },
    setCurrentThreadAttachedLibraryIds(state, payload) {
        state.currentThread = { ...state.currentThread, finagentLibraryIds: payload }
    },
    setThreadAttachedLibraryById(state, payload) {
        const { id, finagentLibraryIds } = payload
        state.threads = state.threads.map((thread) => {
            if (thread.id === id) {
                thread.finagentLibraryIds = finagentLibraryIds;
            }

            return thread;
        })
    },
    setIsLoadingQuestionUsage(state, payload) {
        state.isLoadingQuestionUsage = payload
    },
    setQuestionUsage(state, payload) {
        state.questionUsage = payload
        state.isReachFreePlanLimit = payload.questionsAsked >= payload.questionsLimit;
    },
    updateNumQuestionsUsageAfterAsking(state) {
        const tempData = {
            ...state.questionUsage,
            questionsAsked: state.questionUsage.questionsAsked + 1,
            questionsLeft: state.questionUsage.questionsLeft - 1,
        };
        state.questionUsage = tempData;
        state.isReachFreePlanLimit = tempData.questionsAsked >= tempData.questionsLimit;
    },
    setWishListIsins(state, payload) {
        state.wishListIsins = payload;
    },
    addWishListIsin(state, isin) {
        state.wishListIsins = [...state.wishListIsins, isin];
    },
    removeWishListIsin(state, isin) {
        state.wishListIsins = state.wishListIsins.filter(c => c !== isin);
    },
};

export default {
    state,
    mutations,
}
